import React, { useState, useEffect, useRef } from "react";
import { useParams , useNavigate } from 'react-router-dom';
import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
} from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import "bootstrap/dist/css/bootstrap.min.css";
const BASE_IMAGE_URL = "http://103.235.105.54/admin/uploads/items/";

const Pay = () => {
  const [orderItems, setOrderItems] = useState([]);
  const [splitValue, setSplitValue] = useState(1);
  const [splitsPaid, setSplitsPaid] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [posLoading, setPosLoading] = useState(false); 
  const [cashLoading, setCashLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [stripeOpen, setStripeOpen] = useState(false);
  const [totalAmountToPay, setTotalAmountToPay] = useState(0);
  const { order_id } = useParams();
  const initializedRef = useRef(false);
  const [orderId, setOrderId] = useState(null);
  const [order,setOrder]=useState({});
  const [totalPaid, setTotalPaid] = useState(0);
  const [paidItems, setPaidItems] = useState([]); // indexes fully paid
  const stripePromise = loadStripe("pk_test_...");
  const [customer, setCustomer] = useState({});
  const [tablesData, setTablesData] = useState([]);
  const [selectedTables, setSelectedTables] = useState([]);
  const [orderType,setOrderType]=useState(0);
  const [discounts, setDiscounts] = useState({ flat: [], percentage: [] });
const [splitMode, setSplitMode] = useState(null); // "equal" | "partial" | null
const [customAmount, setCustomAmount] = useState(""); // for partial payments
const [balanceToPay, setBalanceToPay] = useState(0);
const [originalSplitAmount, setOriginalSplitAmount] = useState(0);
const [originalSplitCount, setOriginalSplitCount] = useState(1);
const [hasPaymentStarted, setHasPaymentStarted] = useState(false);
const [noDiscount, setNoDiscount] = useState(false);
const [totalNoDiscount, setTotalNoDiscount] = useState(0);
const [itemPayments, setItemPayments] = useState({});
const [selectAllHide,setSelectAllHide]=useState("block");
const [itemWiseDone, setItemWiseDone] = useState(false);
const [selectedData, setSelectedData] = useState([]);
const [paidData, setPaidData] = useState([]);
const [isCheckboxDisabled,setIsCheckboxDisabled]= useState(false);
const [billButtonVisible,setBillButtonVisible]= useState("none");
  const [customItemAmount, setCustomItemAmount] = useState(0);
const navigate = useNavigate();
  // Load saved order from sessionStorage
  useEffect(() => {
  const branchId = sessionStorage.getItem("branch_id");
  const companyId = sessionStorage.getItem("company_id");

  fetch(`http://103.235.105.54/admin/api/getDiscounts?branch_id=${branchId}&company_id=${companyId}`)
    .then((res) => res.json())
    .then((data) => {
      console.log("Fetched discounts:", data);
      setDiscounts(data);

      // ✅ Optionally save to sessionStorage too
      sessionStorage.setItem("discounts", JSON.stringify(data));
    })
    .catch((err) => console.error("Fetch error:", err));
}, []);

  useEffect(() => {
    const savedData = sessionStorage.getItem("orderResponse");
    if (savedData) {
      const data = JSON.parse(savedData);
      if (data.status && data.data.length > 0) {
        const order = data.data[0];
        setOrderId(order.id);
        setCustomer(order.customer_name || "");
        setOrder(data.data[0]);
        setOrderType(data.data[0]?.order_type);
          setSelectedTables(
  data.data[0].table_id
    ? data.data[0].table_id.split(",").map((id) => id.trim()) // ["4","2"]
    : []
);
        setTotalAmount(order.total_price || 0.00);
        setTotalAmountToPay(order.total_price || 0.00);

        // Format items for local state (this is just for image/title)
        const formattedItems = order.items.map((item) => {
          let imgSrc = "assets/images/foods/foods.png";
          try {
            if (item.images && item.images !== "") {
              const imgs = JSON.parse(JSON.parse(item.images));
              if (imgs.length > 0) {
                imgSrc = "http://103.235.105.54/storage/items/" + imgs[0];
              }
            }
          } catch (e) {
            console.warn("Image parse error:", e);
          }

          return {
            ...item,
            title: item.item_name,
            // keep original fields (netprice etc.) — we don't overwrite them here
          };
        });

        setOrderItems(formattedItems);
      }
    }
  }, []);
 useEffect(() => {
      const fetchTables = () => {
        fetch("http://103.235.105.54/admin/api/tables", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            branch_id: sessionStorage.getItem("branch_id"),
            company_id: sessionStorage.getItem("company_id"),
          }),
        })
          .then((res) => res.json())
          .then((data) => {
            console.log("Fetched data:", data);
    
            if (data.status === true && Array.isArray(data.data)) {
              setTablesData(data.data);
            }
          })
          .catch((err) => console.error("Fetch error:", err));
      };
    
      fetchTables(); // fetch immediately when page loads
    }, []);
  const [selectedItems, setSelectedItems] = useState([]);
  const [discount, setDiscount] = useState(0);

  // Initialize selected items (all checked by default)
  useEffect(() => {
    if (order.items) {
      setSelectedItems(order.items.map((_, i) => i)); // store index of each item
    }
  }, [order.items]);
useEffect(() => {
  // Filter out paid items: only consider currently selectable
  const unpaidIndexes = orderItems.map((_, idx) => idx)
    .filter((idx) => !itemPayments[idx] || itemPayments[idx].status !== "paid");
//alert(orderItems.length+"..."+unpaidIndexes.length);
  if (selectedItems.length === 0 && splitMode !== "item") {
    // No selection: Clear split mode
    setSplitMode(null);
  }
// else if (unpaidIndexes.length>0 && orderItems.length >= unpaidIndexes.length) {
//   setSplitMode("item");
// }
  else if (selectedItems.length === unpaidIndexes.length) {
    // All unpaid items selected: show equal/custom split only
    if (splitMode === "item") setSplitMode("item");
    else if (splitMode === "equal") {setSplitMode("equal");
      setIsCheckboxDisabled(true);
    }
    else if (splitMode === "partial") {setSplitMode("partial");
      setIsCheckboxDisabled(true);
    }
  } else if (selectedItems.length > 0 && selectedItems.length < unpaidIndexes.length) {
    // Some but not all unpaid items: show only item split
    if (splitMode !== "item") setSplitMode("item");
  }
  
  // If user selects all, default to equal split
}, [selectedItems, orderItems, itemPayments, splitMode]);

useEffect(() => {
  //alert(splitMode);
  if (splitMode === "item") {
   // alert("158");
    // when in item mode, auto-fill customAmount with total-with-tax of selected items
    const items = order.items?.filter((_, i) => selectedItems.includes(i)) || [];
    const base = items.reduce(
      (sum, it) => sum + parseFloat((it.price || 0) * (it.qty || 0)), 0
    );
    const tax = items.reduce(
      (sum, it) =>
        sum +
        (parseFloat(it?.cgst) || 0) +
        (parseFloat(it?.sgst) || 0) +
        (parseFloat(it?.igst) || 0) +
        (parseFloat(it?.vat) || 0) +
        (parseFloat(it?.tax) || 0),
      0
    );
    setCustomAmount(Number((base + tax).toFixed(2)));
    setRemainingTotal(Number((base + tax).toFixed(2)));
    
  }
}, [splitMode, selectedItems, order.items]);

useEffect(() => {
 // alert(splitMode);
  if (splitMode === "item" && selectedItems.length > 0) {
    const mergedData = selectedItems
    .filter(idx => orderItems[idx].status!=='paid')
    .map(idx => ({
  item_name: orderItems[idx].item_name,
  qty: orderItems[idx].qty, // initial user selection
  unit_tax : orderItems[idx].tax/orderItems[idx].qty,
  price: orderItems[idx].price,
  maxQty: orderItems[idx].qty // this is the maximum available
}));
   const paidItems = selectedItems
   .filter(idx => orderItems[idx].status==='paid')
   .map(idx => ({
  item_name: orderItems[idx].item_name,
  qty: 0, // initial user selection
  unit_tax : orderItems[idx].tax/orderItems[idx].qty,
  price: orderItems[idx].price,
  maxQty: orderItems[idx].qty // this is the maximum available
}));

    setSelectedData(mergedData);
    setPaidData(paidItems);
  } else {
    setSelectedData([]);
    setPaidData([]);
  }
}, [splitMode, selectedItems, orderItems]);

  // ✅ Recalculate total whenever qty changes
  useEffect(() => {
   console.log("selectedData"+JSON.stringify(selectedData));

  }, [selectedData]);

const recalculateCustomAmount = (newData) => {
  const total = newData.reduce(
    (sum, it) => sum + (it.price * it.qty) + (it.unit_tax * it.qty), 0
  );
  setCustomAmount(Number(total.toFixed(2)));
};
  // ✅ Increase qty
const increaseQty = (index) => {
  setSelectedData(data => {
    const newData = data.map((item, i) =>
      i === index && item.qty < item.maxQty
        ? { ...item, qty: item.qty + 1 }
        : item
    );
    recalculateCustomAmount(newData);
    return newData;
  });
};

const decreaseQty = (index) => {
  setSelectedData(prev => {
    const newData = prev.map((item, i) =>
      i === index && item.qty > 1
        ? { ...item, qty: item.qty - 1 }
        : item
    );
    recalculateCustomAmount(newData);
    return newData;
  });
};


  // Selected items array (subset of order.items)
  const selectedOrderItems = order.items?.filter((_, i) =>
    selectedItems.includes(i)
  );
const calculateDiscount = (subtotal) => {
  let dis1 = 0;
  let dis2 = 0;

  // Flat discount
  if (discounts.flat.length > 0) {
    const flat = parseFloat(discounts.flat[0].offer_amount) || 0;
    const maxAmount = discounts.flat[0].max_amount ? parseFloat(discounts.flat[0].max_amount) : 0;

    if (maxAmount === 0 || subtotal >= maxAmount) {
      dis1 = flat;
    }
  }
//alert(dis1);
  // Percentage discount
  if (discounts.percentage.length > 0) {
    const percent = parseFloat(discounts.percentage[0].offer_percentage) || 0;
    const maxAmount = discounts.percentage[0].max_amount ? parseFloat(discounts.percentage[0].max_amount) : 0;

    if (maxAmount === 0 || subtotal >= maxAmount) {
      dis2 = (subtotal * percent) / 100;
    }
  }
//alert(dis2);
  return dis1 + dis2;
};


  // Subtotal (use netprice as already quantity-included)
  const subtotal = selectedOrderItems?.reduce(
    (sum, item) => sum + parseFloat(item.netprice || 0),
    0
  ) || 0;
  const subtotalwithout = selectedOrderItems?.reduce(
    (sum, item) => sum + parseFloat(item.price *item.qty|| 0),
    0
  ) || 0;
    const taxAmount = selectedOrderItems?.reduce(
    (sum, item) => sum + 
    (parseFloat(item?.cgst) || 0) +
    (parseFloat(item?.sgst) || 0) +
    (parseFloat(item?.igst) || 0) +
    (parseFloat(item?.vat) || 0) +
    (parseFloat(item?.tax) || 0),
    0
  ) || 0;

const totalAmountnotax =(subtotalwithout);


    useEffect(() => {
      
      if(totalAmountnotax>0){
  const totalDiscount = calculateDiscount(totalAmountnotax);
  //alert(totalDiscount);
  setDiscount(totalDiscount);
      }
      if(noDiscount==true)
      { setDiscount(0); }
}, [totalAmountnotax, discounts]);

  
  
  const totalAfterDiscount =
    (subtotal) - (parseFloat(discount) || 0);

  // remainingTotal is the working amount that goes down as items are fully paid
  const [remainingTotal, setRemainingTotal] = useState(totalAfterDiscount || 0);


  useEffect(() => {
    // Consider "no split in progress" when there are no pending itemPayments and splitsPaid === 0
    const anyPending = Object.values(itemPayments).some(
      (p) => !!p && (p.status === "pending" || (p.splitsPaid && p.splitsPaid > 0))
    );
    if (!anyPending && splitsPaid === 0) {
      setRemainingTotal(Number((totalAfterDiscount || 0).toFixed(2)));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalAfterDiscount]);

  // Checkbox toggle
const toggleItem = (index) => {
  // Skip if item is already fully paid
  if (itemPayments[index]?.status === "paid") return;

  setSelectedItems((prev) => {
    const isSelected = prev.includes(index);
    let updated = isSelected 
      ? prev.filter((i) => i !== index) // Uncheck
      : [...prev, index];              // Check

    // 🔹 Only keep unpaid items in selectedItems
    const unpaidIndexes = orderItems
      .map((_, idx) => idx)
      .filter((idx) => itemPayments[idx]?.status !== "paid");

    // Remove any paid indexes from updated selection (guard against legacy state)
    updated = updated.filter(idx => unpaidIndexes.includes(idx));

    // Alert for UI debug
    //alert(updated.length + "..." + unpaidIndexes.length);

    // Check if all unpaid items are selected
    if (updated.length === unpaidIndexes.length && splitMode !== "item") {
      setNoDiscount(false); // all unpaid items selected
      setSelectAllHide("block");
    } 
    else if (updated.length === orderItems.length) {
      setNoDiscount(false);
      setSelectAllHide("block");
      setSplitMode(null);
    }
    else {
      setSelectAllHide("none");
      setNoDiscount(true); // at least one unpaid item unchecked
    }

    return updated;
  });
};


// ✅ Toggle select all unpaid items
const toggleSelectAll = () => {
  //alert("select all");
  const unpaidIndexes = orderItems
    .map((_, idx) => idx)
    .filter((idx) => itemPayments[idx]?.status !== "paid");

  setSelectedItems((prev) => {
    if (prev.length === unpaidIndexes.length) {
      // 🔹 All are currently selected → uncheck all
      setNoDiscount(true);
      return [];
    } 

    else {
      // 🔹 Not all are selected → select all unpaid items
      setNoDiscount(false);
      return unpaidIndexes;
    }
  });
};

  // start split payment for currently selected items (set noOfSplits for each selected idx)
 const startSplitPayment = (splits) => {
  if (!orderItems || orderItems.length === 0) return;
  
  setSplitValue(splits);
  setOriginalSplitCount(splits);

  const totalToSplit = Number(remainingTotal || 0); // take current remaining
  const perSplit = Number((totalToSplit / splits).toFixed(2));
  setOriginalSplitAmount(perSplit);

  // Initialize itemPayments for this split
  const updatedItemPayments = {};
  orderItems.forEach((item, idx) => {
    updatedItemPayments[idx] = {
      ...itemPayments[idx],
      splitsPaid: 0,
      noOfSplits: splits,
      amount: item.netprice || 0,
      status: itemPayments[idx]?.status || "pending",
    };
  });
  setItemPayments(updatedItemPayments);
};

// Compute amount due **per split** using stored originalSplitAmount
const amountDueNow = originalSplitAmount;

  const handleIncrease = () => {
    const next = splitValue + 1;
    setSplitValue(next);
    startSplitPayment(next);
  };
  const handleDecrease = () => {
    if (splitValue > 1) {
      const next = splitValue - 1;
      setSplitValue(next);
      startSplitPayment(next);
    }
  };


const markSplitPaid = (amount) => {
  setSplitsPaid((prev) => prev + 1);
  // ❌ don't touch remainingTotal here
};
  // Called after a successful split payment to update per-item split progress.
useEffect(() => {
  // Convert to number safely
  const remaining = Number(remainingTotal);

  console.log("Remaining Total:", remaining);
  console.log("Split Mode:", splitMode);

  if (splitMode === "partial") {
    setCustomAmount(remaining.toFixed(2)); // Default when switching
  }

  if (remaining === 0 && (splitMode === "partial" || splitMode === "equal")) {
    setBillButtonVisible("block");
  } else {
    setBillButtonVisible("none");
  }
}, [splitMode, remainingTotal]);
useEffect(() => {
  if (splitMode === "item" && order.items?.length > 0) {
    const allPaid = order.items.every((_, index) => itemPayments[index]?.status === "paid");
    if (allPaid) {
      setBillButtonVisible("block");
    } else {
      setBillButtonVisible("none");
    }
  }
}, [splitMode, order.items, itemPayments]);

const applyPayment = (amount) => {
  const amt = Number(amount) || 0; // ensure it's a number

  // ✅ once first payment happens, lock split mode
  if (!hasPaymentStarted) {
    setHasPaymentStarted(true);
  }

  setTotalPaid((prev) => {
    const nextPaid = Number(prev || 0) + amt;
    return Number(nextPaid.toFixed(2));
  });

  setRemainingTotal((prev) => {
    const nextRem = Number(prev || 0) - amt;
    if(nextRem <=0){ setSelectedData([]);}
    return nextRem > 0 ? Number(nextRem.toFixed(2)) : 0;
  });
};
const isSplitStarted = Object.values(itemPayments).some(
  (p) => p.splitsPaid && p.splitsPaid > 0
);
  const handleBillClick = () => {
    navigate(`/bill/${orderId}`);
  };
  // POS payment call
 // POS

const handleItemSplitPayment = () => {
  const newPaidData = [...paidData];

  const updatedSelectedData = selectedItems
    .map((idx) => {
      const baseItem =
        selectedData.find((d) => d.item_name === orderItems[idx].item_name) ||
        orderItems[idx];

      const paidQty = Number(newPaidData[idx]?.qty || 0);
      const selectedQty = Number(baseItem?.qty || 0);
      const totalQty = Number(orderItems[idx]?.qty || 0);

      const updatedPaidQty = paidQty + selectedQty;
      const unpaidQty = Math.max(0, totalQty - updatedPaidQty);

      // ✅ Update paidData
      newPaidData[idx] = {
        ...baseItem,
        qty: Math.min(updatedPaidQty, totalQty),
      };

      // ✅ Calculate remaining unpaid data (if any)
      if (unpaidQty > 0) {
        const unitPrice = Number(baseItem.price || 0);
        const unitTax = Number(baseItem.unit_tax || 0);

        const totalTax = unitTax * unpaidQty;
        const subtotal = unitPrice * unpaidQty;
        const total = subtotal + totalTax;
        const maxqt=unpaidQty;
        //alert("unpaid"+maxqt);
        return {
          ...baseItem,
          qty: unpaidQty,
          tax: totalTax,
          maxQty:maxqt,
          subtotal,
          total,
        };
      }

      return null; // fully paid
    })
    .filter(Boolean);

  // ✅ Update payment status
  setItemPayments((prev) => {
    const updated = { ...prev };
    selectedItems.forEach((idx) => {
      const totalQty = Number(orderItems[idx]?.qty || 0);
      const paidQty = Number(newPaidData[idx]?.qty || 0);
      const unitPrice = Number(orderItems[idx]?.price || 0);
      const paidAmount = unitPrice * paidQty;
//alert("paidQty...."+paidQty+"Total  "+totalQty);
      updated[idx] = {
        ...updated[idx],
        status: paidQty >= totalQty ? "paid" : "partial",
        paidAmount,
        splitsPaid: (updated[idx]?.splitsPaid || 0) + 1,
      };
    });
    return updated;
  });

  setPaidData(newPaidData);
  setSelectedData(updatedSelectedData);
  recalculateCustomAmount(updatedSelectedData);
};


const handlePOSPayment = async (amount) => {
  try {
    setPosLoading(true);
    const res = await fetch("http://103.235.105.54/admin/api/purchase", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        total_amount: amount,
        branch_id: sessionStorage.getItem("branch_id"),
        company_id: sessionStorage.getItem("company_id"),
        order_id: order.id,
        customer_id: 1,
        pos_prints_receipt: true,
      }),
    });
    const data = await res.json();
    setResult(data.external_data?.receipt || data);

    // ✅ update totals
    applyPayment(amount);
   
        if (splitMode === "item") {
     handleItemSplitPayment();
    }
    alert(`POS Payment success for ₹${amount}`);
  } catch (err) {
    console.error("POS Payment Error:", err);
    alert("POS Payment failed!");
  } finally {
    setPosLoading(false);
  }
};

// Cash
const handleCashPayment = async (amount) => {
  try {
    setCashLoading(true);
    const res = await fetch("http://103.235.105.54/admin/api/cashPurchase", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        total_amount: amount,
        branch_id: sessionStorage.getItem("branch_id"),
        company_id: sessionStorage.getItem("company_id"),
        order_id: order.id,
        customer_id: 1,
        cash_amount: amount,
        pos_prints_receipt: false,
      }),
    });
    const data = await res.json();
    setResult(data);

    // ✅ update totals
    applyPayment(amount);
        if (splitMode === "item") {
     handleItemSplitPayment();
    }
    alert(`Cash Payment success for ₹${amount}`);
  } catch (err) {
    console.error("Cash Payment Error:", err);
    alert("Cash Payment failed!");
  } finally {
    setCashLoading(false);
  }
};

  const parseImages = (images) => {
    try {
      let parsed = JSON.parse(images); // first parse
      if (typeof parsed === "string") {
        parsed = JSON.parse(parsed);
      }
      return parsed;
    } catch (e) {
      console.error("Image parse error:", e, images);
      return [];
    }
  };

  return (
    <main className="main-wrapper">
      <div className="main-content">

        <div className="container-fluid">
          <div className="row g-8">
            {/* Left Column: Order Summary */}
           <div className="col-lg-6">
  <div className="order-box p-3 border rounded shadow-sm">

{orderType === 2 ? (
  <h5>
    Customer: {customer ? customer: "Dine-in Customer"}
  </h5>
) : (
  selectedTables.length > 0 && (
    <div className="mb-3">
      <label>Selected Tables:</label>
      <div className="d-flex flex-wrap gap-2 mt-2">
        {tablesData
          .filter((t) => selectedTables.includes(String(t.id))) // ✅ ensure ID match
          .map((t) => (
            <label
              key={t.id}
              className="border p-2 rounded"
              style={{ cursor: "pointer",backgroundColor:"#8fdce4",fontSize:"12px" }} 
            >
              {/* <input
                type="checkbox"
                checked={selectedTables.includes(String(t.id))}
                readOnly
              />
              <br /> */}
              {t.table_code || t.table_name}
            </label>
          ))}
      </div>
    </div>
  )
)}


    <div className="d-flex justify-content-between mb-3">
      <div className="order-header">
        Order’s Summary <small className="text-muted">#{order?.id}</small>
      </div>
      <div style={{display:selectAllHide}}>
        <input
          type="checkbox"

          checked={selectedItems.length === order.items?.length}
          onChange={toggleSelectAll}
          disabled={isCheckboxDisabled}
        />{" "}
        Select All
      </div>
    </div>

    {/* Order Items */}
    {order.items?.map((item, index) => {
      let imgs = [];
      try {
        imgs = parseImages(item.images);
      } catch (e) {
        imgs = [];
      }

      const imgSrc =
        imgs.length > 0
          ? BASE_IMAGE_URL + imgs[0]
          : "assets/images/foods/foods.png";

      return (
        <div
          key={index}
          className="order-item d-flex justify-content-between align-items-center mb-3"
        >
          <div className="d-flex align-items-center gap-2">
            <img
              src={imgSrc}
              alt={item.item_name}
              style={{ width: "60px", height: "60px", objectFit: "cover" }}
              className="rounded"
            />
            <div>
              <div className="title fw-semibold">
                {item?.item_name} {item.attribute}<span style={{fontSize:"9px"}}>( with tax - {item.netprice}) </span>
              </div>
              <small>
                (₹{item.baseprice}) × {item.qty}
              </small>{" "}
              <small>= ₹{(item.baseprice * item.qty).toFixed(2)}</small>
            </div>
          </div>
          <div className="d-flex align-items-center">
            <span 
            style={{
    color: "blue",
    backgroundColor: "yellow",
    borderRadius: "50px", // makes it oval
    padding: "3px 10px",  // space inside
    fontWeight: "bold",
    display: "inline-block", // keeps oval shape
  }}
            >
{itemPayments[index]?.status === "paid" ?"PAID":"---"}
          </span>
          </div>

          <div className="d-flex align-items-center">
            <input 
              type="checkbox"
               checked={
    itemPayments[index]?.status === "paid" 
      ? true 
      : selectedItems.includes(index)
  }
              onChange={() => toggleItem(index)}
              disabled={isCheckboxDisabled || itemPayments[index]?.status === "paid"} // disable if fully paid
            />
<span>{(item.baseprice * item.qty).toFixed(2)}</span>
        
          </div>
        </div>
      );
    })}

    {/* Payment Summary */}
    <div className="mt-4">
      <h6 className="fw-bold">Payment Summary</h6>
 <div className="d-flex justify-content-between align-items-center mt-2">
        <span>Total</span>
        <span className="text-primary">
          {totalAmountnotax.toFixed(2)}
         </span>
      </div>
       <div className="d-flex justify-content-between align-items-center mt-2">
        <span>Tax</span>
        <span className="text-primary">{taxAmount.toFixed(2)}</span>
      </div>
      <div className="d-flex justify-content-between align-items-center mt-2">
        <span>Discount</span>
        <span className="text-primary">-{discount.toFixed(2) }
         </span>
      </div>

      <div className="d-flex justify-content-between mt-2">
        <span>Grand Total</span>
        <span className="text-primary">
          ₹{totalAfterDiscount > 0 ? totalAfterDiscount.toFixed(2) : "0.00"}
        </span>
      </div>
    </div>
  </div>
</div>


            {/* Right Column: Payment Section */}
            <div className="col-lg-6">
              <div className="summary-box p-4">
                <h4>Total Amount- ₹{totalAfterDiscount > 0 ? totalAfterDiscount.toFixed(2) : "0.00"}</h4>

<div className="amount display-6 fw-bold">
  Total Paid : ₹{totalPaid.toFixed(2)}
</div>
<div className="text-center mt-2">
      Remaining Balance: <b>₹{remainingTotal.toFixed(2)}</b>
</div>
<div className="row justify-content-center gap-3 mt-2">
 <button
  className="btn col-lg-3 btn-primary"
  onClick={() => {
    if (!hasPaymentStarted) {
      setSplitMode("equal");
      startSplitPayment(splitValue); // your existing logic
    }
  }}
  disabled={
    hasPaymentStarted && splitMode !== "equal" ||
    (splitMode === "item") // Disable button in item-only case
  }
>
  Equal Split
</button>

<button
  className="btn col-lg-3 btn-primary"
  onClick={() => {
    if (!hasPaymentStarted) {
      setSplitMode("partial");
      setCustomAmount("");
    }
  }}
  disabled={
    hasPaymentStarted && splitMode !== "partial" ||
    (splitMode === "item") // Disable button in item-only case
  }
>
  Custom Split
</button>


  <button className="btn col-lg-3 btn-primary" onClick={handleBillClick}  style={{ display: billButtonVisible }}>Bill</button>
</div>
                {/* Split Section */}
 {splitMode === "equal" && (
  <div className="mt-4">
    <h6>Number of Splits</h6>
    <div className="d-flex justify-content-center align-items-center gap-2 my-2">
      <button className="btn btn-outline-secondary" onClick={handleDecrease}>-</button>
      <div className="split-box border px-4 py-2 rounded bg-light">
        {splitValue}
      </div>
      <button className="btn btn-outline-secondary" onClick={handleIncrease}>+</button>
    </div>
    <h6 className="mt-3">Amount Per Split</h6>
    <div className="split-box w-50 mx-auto border px-4 py-2 rounded bg-light">
      ₹{amountDueNow}
    </div>
    
  </div>
)}

{splitMode === "partial" && (
  <div className="mt-4">
    <h6>Enter Amount to Pay</h6>
    <input
      type="number"
      className="form-control w-25 mx-auto"
      value={customAmount}
      onChange={(e) => setCustomAmount(e.target.value)}
      placeholder="Enter amount"
      max={remainingTotal}
    />
    
  </div>
)}
{splitMode === "item" && selectedData.length > 0 && (
  <div className="mt-4">
        <div className="border p-3 rounded w-75 mx-auto">
       {selectedData.length > 0 && (
  <table className="table" style={{fontSize:"14px"}}>
    <thead>
      <tr>
        <th>Item Name</th>
        <th>Quantity</th>
{/*        
        <th>Price</th>
        <th>Tax</th> */}
        <th>Price with Tax</th>
      </tr>
    </thead>
    <tbody>
      {selectedData.map((item, index) => (
        <tr key={index}>
          <td>{item.item_name}</td>
          <td>
             <div style={{ display: "flex", alignItems: "center" }}>
            <button
              className="btn btn-sm btn-outline-secondary"
                style={{
    height: "18px",
    width: "18px",
    fontSize: "12px",
    padding: "0",
    lineHeight: 1,
    textAlign: "center"
  }}
              onClick={() => decreaseQty(index)}
              disabled={item.qty <= 1}
            >–</button>
            <span className="mx-2">{item.qty}</span>
            <button
              className="btn btn-sm btn-outline-secondary"
                style={{
    height: "18px",
    width: "18px",
    fontSize: "12px",
    padding: "0",
    lineHeight: 1,
    textAlign: "center"
  }}
              onClick={() => increaseQty(index)}
              disabled={item.qty >= item.maxQty}
            >+</button>
            </div>
          </td>
        
          {/* <td> {item.price * item.qty}</td>
          <td> {item.unit_tax * item.qty}</td> */}
          <td>₹ {(item.price * item.qty) + (item.unit_tax * item.qty)}</td>
        </tr>
      ))}
    </tbody>
  </table>
)}

    </div>
    <h6>The Amount to Pay</h6>
    <input
      type="number"
      readOnly
      className="form-control w-25 mx-auto"
      value={customAmount}
      placeholder="Enter amount"
      max={remainingTotal}
    />
  </div>
)}

                {/* Action Buttons */}
                 <h5 className="mt-3">Pay By</h5>
                <div className="row justify-content-center gap-3 mt-2">
                  <button className="btn col-lg-3 btn-success" style={{display:"none"}}
                   onClick={() => setStripeOpen(true)}
                  disabled={loading}
                  >{loading ? "Processing..." : "💵 Card "}</button>

<button
  className="btn col-lg-3 btn-success"
  onClick={() => {
    const payAmount =
      splitMode === "equal" ? amountDueNow : Number(customAmount || 0);

    if (payAmount <= 0 || payAmount > remainingTotal) {
      alert("Enter valid amount");
      return;
    }

    handlePOSPayment(payAmount);
    if (splitMode === "partial") setCustomAmount(""); // reset input
  }}
>
  {posLoading ? "Processing..." : `POS ₹${splitMode === "equal" ? amountDueNow : customAmount || 0}`}
</button>

<button
  className="btn col-lg-3 btn-success"
  onClick={() => {
    const payAmount =
      splitMode === "equal" ? amountDueNow : Number(customAmount || 0);

    if (payAmount <= 0 || payAmount > remainingTotal) {
      alert("Enter valid amount");
      return;
    }

    handleCashPayment(payAmount);
    if (splitMode === "partial") setCustomAmount(""); // reset input
  }}
>
  {cashLoading ? "Processing..." : `CASH ₹${splitMode === "equal" ? amountDueNow : customAmount || 0}`}
</button>

                </div>

{/* <div className="row justify-content-center gap-3 mt-2">
     {result && (
  <div style={{ marginTop: "20px" }}>
    <h4>Payment Response:</h4>
    <pre style={{ whiteSpace: "pre-wrap" }}>
      {typeof result === "string"
        ? result // show raw receipt with line breaks
        : JSON.stringify(result, null, 2)}
    </pre>
  </div>
)}
</div> */}
                
              </div>
            </div>
          </div>
        </div>
      </div>

      {stripeOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <Elements stripe={stripePromise}>
              <CheckoutForm amount={totalAmount}  onClose={() => setStripeOpen(false)} />
            </Elements>
          </div>
        </div>
      )}
    </main>
  );
};

export default Pay;
